import React, { useContext } from "react";
import { TextField } from "@mui/material";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const InitialNotes = ({ initialNotes, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="initialNotes" className="planField">
            <GroupBDRBiologists />
            <TextField
                name="initialNotes"
                label={xplanLabels.initialNotes}
                InputLabelProps={{ shrink: true }}
                type="text"
                required={required.includes("initialNotes")}
                value={initialNotes ? initialNotes : ""}
                onChange={(e) => handleChange("initialNotes", e.target.value)}
                multiline
                minRows={1}
                className="fullLength"
                disabled={!canEdit}
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"initialNotes"} />}
        </div>
    );
};

export default InitialNotes;
